import React from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
interface SlideLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
  theme?: 'light' | 'dark' | 'brand';
}
export function SlideLayout({
  children,
  title,
  subtitle,
  currentSlide,
  totalSlides,
  onNext,
  onPrev,
  theme = 'light'
}: SlideLayoutProps) {
  const bgClass = {
    light: 'bg-white text-slate-900',
    dark: 'bg-slate-900 text-white',
    brand: 'bg-indigo-600 text-white'
  }[theme];
  return <div className={`w-full h-screen flex flex-col relative overflow-hidden ${bgClass} transition-colors duration-500`} data-id="element-393">
      {/* Header / Branding */}
      <header className="absolute top-0 left-0 w-full p-8 flex justify-between items-center z-10" data-id="element-394">
        <div className="flex items-center gap-2" data-id="element-395">
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-lg ${theme === 'light' ? 'bg-indigo-600 text-white' : 'bg-white text-indigo-600'}`} data-id="element-396">
            E
          </div>
          <span className={`font-bold text-xl tracking-tight ${theme === 'light' ? 'text-slate-900' : 'text-white'}`} data-id="element-397">
            EduAssess
          </span>
        </div>
        <div className={`text-sm font-medium opacity-60 ${theme === 'light' ? 'text-slate-500' : 'text-slate-300'}`} data-id="element-398">
          Investor Deck
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col justify-center px-8 md:px-16 lg:px-24 max-w-7xl mx-auto w-full animate-in fade-in duration-700 slide-in-from-bottom-4" data-id="element-399">
        {(title || subtitle) && <div className="mb-12" data-id="element-400">
            {title && <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight" data-id="element-401">
                {title}
              </h2>}
            {subtitle && <p className={`text-xl md:text-2xl max-w-3xl ${theme === 'light' ? 'text-slate-600' : 'text-indigo-100'}`} data-id="element-402">
                {subtitle}
              </p>}
          </div>}
        <div className="w-full" data-id="element-403">{children}</div>
      </main>

      {/* Footer / Navigation */}
      <footer className="absolute bottom-0 left-0 w-full p-8 flex justify-between items-end z-10" data-id="element-404">
        <div className="flex gap-1" data-id="element-405">
          {Array.from({
          length: totalSlides
        }).map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${i === currentSlide - 1 ? theme === 'light' ? 'w-8 bg-indigo-600' : 'w-8 bg-white' : theme === 'light' ? 'w-2 bg-slate-200' : 'w-2 bg-white/20'}`} data-id="element-406" />)}
        </div>

        <div className="flex items-center gap-4" data-id="element-407">
          <span className={`text-sm font-mono ${theme === 'light' ? 'text-slate-400' : 'text-white/40'}`} data-id="element-408">
            {currentSlide} / {totalSlides}
          </span>
          <div className="flex gap-2" data-id="element-409">
            <button onClick={onPrev} disabled={currentSlide === 1} className={`p-2 rounded-full transition-all ${theme === 'light' ? 'hover:bg-slate-100 disabled:opacity-30 text-slate-900' : 'hover:bg-white/10 disabled:opacity-30 text-white'}`} data-id="element-410">
              <ChevronLeft className="w-6 h-6" data-id="element-411" />
            </button>
            <button onClick={onNext} disabled={currentSlide === totalSlides} className={`p-2 rounded-full transition-all ${theme === 'light' ? 'hover:bg-slate-100 disabled:opacity-30 text-slate-900' : 'hover:bg-white/10 disabled:opacity-30 text-white'}`} data-id="element-412">
              <ChevronRight className="w-6 h-6" data-id="element-413" />
            </button>
          </div>
        </div>
      </footer>
    </div>;
}